import notDeleted from '../notDeleted'

/**
 * '9:00' en '09:00' komen allebei voor; de vergelijking moet ze gelijk zien.
 *
 * @param {unknown} value
 * @returns {string}
 */
const normalizeTime = (value) => {
    const text = typeof value === 'string' ? value.trim() : ''
    const match = /^(\d{1,2}):(\d{2})$/.exec(text)
    return match ? `${match[1].padStart(2, '0')}:${match[2]}` : text
}

/**
 * @typedef {object} PresenceSlot
 * @property {string} docId - Het vaste ID van dit blok op deze dag (presenceReportDocId)
 * @property {string} date - De dag in de vorm van het `Date`-veld ('dinsdag 20 oktober 2026')
 * @property {string} start - Starttijd van het roosterblok ('HH:MM')
 */

/**
 * Het aanwezigheidsrapport van één roosterblok op één dag, of null.
 *
 * Eerst het vaste document dat de agenda en de nachtklus allebei schrijven.
 * Daarna een oudere melding onder een willekeurig ID: zelfde dag en zelfde
 * starttijd, of zonder starttijd (geldt dan voor elk blok die dag) — dezelfde
 * blokregel als de nachtklus (functions/personas/manualSlotRegistration.js,
 * vastgepind door findSlotPresenceReport.parity.test.js).
 *
 * Tot 2026-10-21 zocht de agenda alleen op datum: bij twee blokken op één dag
 * verdwenen de knoppen van het middagblok zodra de ochtend geregistreerd was.
 *
 * AI-CONTEXT: See docs/pitfalls.md#database-job-dedups-only-on-its-own-docid
 *
 * @param {Array<object> | null | undefined} reports - PersonaPresenceReports van deze deelnemer (met docid)
 * @param {PresenceSlot} slot
 * @returns {object | null}
 */
const findSlotPresenceReport = (reports, { docId, date, start }) => {
    const live = (reports || []).filter((r) => r && notDeleted(r))

    const fixed = docId ? live.find((r) => r.docid === docId) : null
    if (fixed) return fixed

    const slotStart = normalizeTime(start)
    return live.find((r) =>
        r.Date === date && (!r.Start || normalizeTime(r.Start) === slotStart)
    ) || null
}

export default findSlotPresenceReport
